const  IconPlus = () => {

    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g>
                <line y1="5.5" x2="12" y2="5.5" stroke="#405363"/>
                <line x1="6" y1="12" x2="6" stroke="#405363"/>
            </g>
        </svg>
    )

}

export default IconPlus;
